import React, { useState, useEffect } from "react";
import { IKImage, IKContext } from "imagekitio-react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

const ImgMasonry = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (!selectedImage) {
      return;
    }
    const bodyStyle = document.body.style;
    const htmlStyle = document.documentElement.style;
    const prev = {
      bodyOverflow: bodyStyle.overflow,
      htmlOverflow: htmlStyle.overflow,
      bodyTouchAction: bodyStyle.touchAction,
      bodyOverscroll: bodyStyle.overscrollBehavior,
      htmlOverscroll: htmlStyle.overscrollBehavior,
    };
    const preventScroll = (event) => event.preventDefault();

    bodyStyle.overflow = "hidden";
    htmlStyle.overflow = "hidden";
    bodyStyle.touchAction = "none";
    bodyStyle.overscrollBehavior = "none";
    htmlStyle.overscrollBehavior = "none";
    window.addEventListener("wheel", preventScroll, { passive: false });
    window.addEventListener("touchmove", preventScroll, { passive: false });

    return () => {
      window.removeEventListener("wheel", preventScroll);
      window.removeEventListener("touchmove", preventScroll);
      bodyStyle.overflow = prev.bodyOverflow;
      htmlStyle.overflow = prev.htmlOverflow;
      bodyStyle.touchAction = prev.bodyTouchAction;
      bodyStyle.overscrollBehavior = prev.bodyOverscroll;
      htmlStyle.overscrollBehavior = prev.htmlOverscroll;
    };
  }, [selectedImage]);

  const ImageWithSkeleton = ({ path, alt, onClick }) => {
    const [loaded, setLoaded] = useState(false);

    return (
      <div
        className={`p-2 dark:bg-[#201c1c] transition-opacity duration-1000 ${
          isMounted ? "opacity-100" : "opacity-0"
        }`}
        style={{
          animation: isMounted ? "fadeIn 1s ease-in-out" : "none",
        }}
      >
        <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      `}</style>
        <div className="relative overflow-hidden rounded shadow-lg bg-slate-200">
          {!loaded && (
            <div className="absolute inset-0 bg-slate-200 animate-pulse" />
          )}
          <IKImage
            path={path}
            alt={alt}
            className="w-full h-auto rounded cursor-pointer"
            style={{ visibility: loaded ? "visible" : "hidden" }}
            onClick={onClick}
            onLoad={() => setLoaded(true)}
            onContextMenu={(e) => e.preventDefault()}
          />
        </div>
      </div>
    );
  };

  return (
    <IKContext urlEndpoint="https://ik.imagekit.io/bbwxfzjdl2zg">
      <ResponsiveMasonry
        columnsCountBreakPoints={{ 500: 1, 750: 2, 1100: 3, 1500: 4 }}
      >
        <Masonry>
          {images.map((path, index) => (
            <ImageWithSkeleton
              key={path}
              path={path}
              alt={`Image ${index + 1}`}
              onClick={() => setSelectedImage(path)}
            />
          ))}
        </Masonry>
      </ResponsiveMasonry>
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
          role="dialog"
          aria-modal="true"
          onClick={() => setSelectedImage(null)}
          onWheel={(e) => e.preventDefault()}
        >
          <div
            className="relative max-w-5xl w-full max-h-[90vh] h-full flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="absolute right-2 top-2 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-white/90 text-sm font-semibold text-black shadow hover:bg-white"
              onClick={() => setSelectedImage(null)}
              aria-label="Close modal"
            >
              <span aria-hidden="true">X</span>
            </button>
            <IKImage
              path={selectedImage}
              className="max-w-full max-h-[90vh] w-auto h-auto object-contain rounded"
              alt="Selected image"
              draggable={false}
              onContextMenu={(e) => e.preventDefault()}
            />
          </div>
        </div>
      )}
    </IKContext>
  );
};

export default ImgMasonry;
